<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card card-w-title">				
				<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
			</div>
			<div class="card">
				<Panel header="Datos Personales del Docente" style="height: 100%">
				<div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12 p-md-4">
						<label for="l1">Apellido Paterno</label>
						<InputText id="app" v-model="datosdocente.apellidoPaterno" autofocus required="true" :class="{'p-invalid': submitted && validarErrores.apellidoPaterno}"/>
						<small class="p-error" v-show="submitted && validarErrores.apellidoPaterno">El Apellido Paterno es requerido.</small>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<label for="l2">Apellido Materno</label>
						<InputText id="apm" v-model="datosdocente.apellidoMaterno" required="true" :class="{'p-invalid': submitted && validarErrores.apellidoMaterno}"/>
						<small class="p-error" v-show="submitted && validarErrores.apellidoMaterno">El Apellido Materno es requerido.</small>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<label for="l3">Nombre (s)</label>
						<InputText id="nom" v-model="datosdocente.nombreDocente" required="true" :class="{'p-invalid': submitted && validarErrores.nombreDocente}"/>
						<small class="p-error" v-show="submitted && validarErrores.nombreDocente">El Nombre del Docente es requerido.</small>
					</div>
					<div class="p-field p-col-12">
						<label for="l4">Institución en que labora actualmente: </label>
						<InputText id="inst" v-model="datosdocente.institucion" required="true" :class="{'p-invalid': submitted && validarErrores.institucionLabora}"/>
						<small class="p-error" v-show="submitted && validarErrores.institucionLabora">La Instutición en que labora es requerido.</small>
					</div>
					<div class="p-field p-col-12 p-md-6">
						<label for="l5">Puesto en la institución:</label>
						<InputText id="puesto" v-model="datosdocente.puesto" required="true" type="text" :class="{'p-invalid': submitted && validarErrores.puestoOcupa}"/>
						<small class="p-error" v-show="submitted && validarErrores.puestoOcupa">El puesto que ocupa es requerido.</small>
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label for="l6">Fecha de Ingreso a la Institución:</label>
						<Calendar id="fecha1" v-model="datosdocente.fechaIngreso" dateFormat="yyyy-mm-dd" :yearNavigator="true" yearRange="1950:2010" placeholder="0000-00-00" :showIcon="true" :class="{'p-invalid': submitted && validarErrores.fechaIngreso}" />
						<small class="p-error" v-show="submitted && validarErrores.fechaIngreso">La fecha de ingreso es requerida.</small>
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label for="l7">Fecha de Nacimiento:</label>
						<Calendar id="fecha2" v-model="datosdocente.fechaNacimiento" dateFormat="yyyy-mm-dd" :yearNavigator="true" yearRange="1950:2010" placeholder="0000-00-00" :showIcon="true" :class="{'p-invalid': submitted && validarErrores.fechaNacimiento}" />
						<small class="p-error" v-show="submitted && validarErrores.fechaNacimiento">La fecha de nacimiento es requerida.</small>
					</div>
					<div class="p-field p-col-12 p-md-6">
					</div>
					<div class="p-field p-col-12 p-md-6">
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label for="l8">No. Plaza:</label>
						<InputText id="noPlaza" v-model="datosdocente.noPlaza" required="true" :class="{'p-invalid': submitted && validarErrores.noPlaza}"/>
						<small class="p-error" v-show="submitted && validarErrores.noPlaza">El Número de Plaza es requerido.</small>
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label for="l9">Tipo Contratación:</label>						
						<Dropdown id="tipocontrato" v-model="datosdocente.tipoContrato" :options="tiposcontratos" optionLabel="label" required="true" placeholder="Tipo de Contrato" :class="{'p-invalid': submitted && validarErrores.tipoContrato}">							
						<template #value="slotProps">
							<div v-if="slotProps.value && slotProps.value.value">
								<span>{{slotProps.value.value}}</span>
							</div>
							<div v-else-if="slotProps.value && !slotProps.value.value">
								<span>{{slotProps.value}}</span>
							</div>
							<span v-else>
								<div v-if="datosdocente.tipoContrato === null ">
									{{slotProps.placeholder}}
								</div>
								<div v-else>
									{{datosdocente.tipoContrato}}
								</div>
							</span>
						</template>
						</Dropdown>
						<small class="p-error" v-show="submitted && validarErrores.tipoContrato">Debe seleccionar un Tipo de Contrato.</small>				
					</div>					
					<div class="p-field p-col-12 p-md-3">
						<label for="l10">Categoría:</label>
						<Dropdown id="categoria" v-model="datosdocente.categoria" :options="tiposcategoria" optionLabel="label" required="true" placeholder="Categorías" :class="{'p-invalid': submitted && validarErrores.categoria}">							
						<template #value="slotProps">
							<div v-if="slotProps.value && slotProps.value.value">
								<span>{{slotProps.value.value}}</span>
							</div>
							<div v-else-if="slotProps.value && !slotProps.value.value">
								<span>{{slotProps.value}}</span>
							</div>
							<span v-else>
								<div v-if="datosdocente.categoria === null ">
									{{slotProps.placeholder}}
								</div>
								<div v-else>
									{{datosdocente.categoria}}
								</div>
							</span>
						</template>
						</Dropdown>
						<small class="p-error" v-show="submitted && validarErrores.categoria">Debe seleccionar una Categoría.</small>								
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label for="l11">RFC del Docente:</label>
						<InputText id="rfcDocente" v-model="datosdocente.rfcPersonal" required="true" :class="{'p-invalid': submitted && validarErrores.rfcPersonal}"/>	
						<small class="p-error" v-show="submitted && validarErrores.rfcPersonal">El RFC es requerido.</small>						
					</div>
					
				</div>
				</Panel>
				<br>
				<Toast/>
				<Toolbar class="p-mb-4">
					<template v-slot:right>
						<Button label="Actualizar" icon="pi pi-pencil" class="p-button-success p-mr-2" @click="actualizarDatosForm" />						
					</template>
				</ToolBar>
			</div>			
		</div>
	</div>
</template>
<script>
import apiDatosPersonal from '@/service/DatosPersonalService';

	export default {
		data() {
			return {
				datosAlmacenados:[],
				datosdocente: {
					noPlaza: '',        
					nombreDocente: '',
					apellidoPaterno: '',
					apellidoMaterno: '',
					institucion: '',
					puesto: '',
					fechaIngreso: '',
					fechaNacimiento: '',
					tipoContrato: null,
					categoria: null,
					rfcPersonal: ''
				},					
				breadcrumbHome: {icon: 'pi pi-home', to: '/'},
				breadcrumbItems: [
					{label:'Curriculum Vitae (CONAIC)'},
					{label:'Datos Personales'}
				],
				tiposcontratos: [
						{label: 'Por Contrato', value: 'Por Contrato'},
						{label: 'Temporal', value: 'Temporal'},
						{label: 'Definitivo', value: 'Definitivo'}
				],
				validarErrores: {},
				tiposcategoria: [
						{label: 'Profesor Asignatura A', value: 'Profesor Asignatura A'},
						{label: 'Profesor Asignatura B', value: 'Profesor Asignatura B'},
						{label: 'PTC Asociado A', value: 'PTC Asociado A'},
						{label: 'PTC Asociado B', value: 'PTC Asociado B'},
						{label: 'PTC Asociado C', value: 'PTC Asociado C'},
						{label: 'PTC Titular A', value: 'PTC Titular A'},
						{label: 'PTC Titular B', value: 'PTC Titular B'},
						{label: 'PTC Titular C', value: 'PTC Titular C'}						
					],
				tipoContrato:'',
				tipoCatego:'',
				submitted: false
			}
		},
		created() {
			this.limpiarInputs();
			this.getDatosPersonal();		
		},
		mounted() {
			this.limpiarInputs();
			this.getDatosPersonal();			
		},
		updated(){
			this.getDatosPersonal();
		},
		methods: {	
			limpiarInputs(){
				this.datosdocente= {
					noPlaza: '',        
					nombreDocente: '',
					apellidoPaterno: '',
					apellidoMaterno: '',
					institucion: '',
					puesto: '',
					fechaIngreso: '',
					fechaNacimiento: '',
					tipoContrato: null,
					categoria: null,
					rfcPersonal: ''
				}
			},	 
			getDatosPersonal: async function() {   //Leer datos desde el API REST
				const data = await apiDatosPersonal.getDatosPersonal(window.sessionStorage.getItem('noPlaza'));
				this.datosAlmacenados = data;

				this.datosdocente={
					noPlaza: this.datosAlmacenados.noPlaza,        
					nombreDocente: this.datosAlmacenados.nombreDocente,
					apellidoPaterno: this.datosAlmacenados.apellidoPaterno,
					apellidoMaterno: this.datosAlmacenados.apellidoMaterno,
					institucion: this.datosAlmacenados.institucionLabora,
					puesto: this.datosAlmacenados.puestoOcupa,
					fechaIngreso: this.datosAlmacenados.fechaIngreso,
					fechaNacimiento: this.datosAlmacenados.fechaNacimiento,
					tipoContrato: this.datosAlmacenados.tipoContrato,
					categoria: this.datosAlmacenados.categoria,
					rfcPersonal: this.datosAlmacenados.rfcPersonal	
				} 
			},
			updateDatosPersonal: async function() { 
						
			if(this.datosdocente.tipoContrato === null){
					this.tipoContrato = this.datosdocente.tipoContrato.value 
			}
			else{
					this.tipoContrato = this.datosdocente.tipoContrato 
			}

			if(this.datosdocente.categoria === null){
					this.tipoCatego = this.datosdocente.categoria.value 
			}
			else{
					this.tipoCatego = this.datosdocente.categoria 
			}

				const requestData = {
					noPlaza: this.datosdocente.noPlaza,        
					nombreDocente: this.datosdocente.nombreDocente,
					apellidoPaterno: this.datosdocente.apellidoPaterno,
					apellidoMaterno: this.datosdocente.apellidoMaterno,
					institucion: this.datosdocente.institucion,
					puesto: this.datosdocente.puesto,
					fechaIngreso: this.datosdocente.fechaIngreso,
					fechaNacimiento: this.datosdocente.fechaNacimiento,
					tipoContrato: this.datosdocente.tipoContrato.value,
					categoria: this.datosdocente.categoria.value,
					rfcPersonal: this.datosdocente.rfcPersonal			
				};

				await apiDatosPersonal.updateDatosPersonal(this.datosdocente.noPlaza,requestData); 
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Datos Personales actualizados', life: 3000});
			},
			actualizarDatosForm(){
				this.submitted = true;
				if (this.validarForm() ) {				
					this.updateDatosPersonal();					
				}
			},
			validarForm() {
				
				if (!this.datosdocente.nombreDocente.trim())
					this.validarErrores['nombreDocente'] = true;
				else
					delete this.validarErrores['nombreDocente'];

				if (!this.datosdocente.apellidoPaterno.trim())
					this.validarErrores['apellidoPaterno'] = true;
				else
					delete this.validarErrores['apellidoPaterno'];

				if (!this.datosdocente.apellidoMaterno.trim())
					this.validarErrores['apellidoMaterno'] = true;
				else
					delete this.validarErrores['apellidoMaterno'];
				
				if (!this.datosdocente.institucion.trim())
					this.validarErrores['institucionLabora'] = true;
				else
					delete this.validarErrores['institucionLabora'];
				
				if (!this.datosdocente.puesto.trim())
					this.validarErrores['puestoOcupa'] = true;
				else
					delete this.validarErrores['puestoOcupa'];
				
				if (!this.datosdocente.noPlaza.trim())
					this.validarErrores['noPlaza'] = true;
				else
					delete this.validarErrores['noPlaza'];
				
				if (!this.datosdocente.rfcPersonal.trim())
					this.validarErrores['rfcPersonal'] = true;
				else
					delete this.validarErrores['rfcPersonal'];

				if (this.datosdocente.categoria===null)
					this.validarErrores['categoria'] = true;
				else
					delete this.validarErrores['categoria'];

				if (this.datosdocente.tipoContrato===null)
					this.validarErrores['tipoContrato'] = true;
				else
					delete this.validarErrores['tipoContrato'];

				return !Object.keys(this.validarErrores).length;
			}
		}
	}
</script>